import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link } from 'react-router-dom';
import '../../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../../Components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";
import staffSvg from '../../../assets/images/svg/staff.svg'
import { numberWithCommas } from "../../../helpers/globalHelper"
import toastr from "toastr";

import DeleteModal from '../../../Components/Common/DeleteModal';

import { Col, Row, UncontrolledTooltip, Modal, ModalHeader, ModalBody, Form, Input, FormFeedback, Label, Card, CardBody, Button, Badge } from "reactstrap";

//flatpickr
import "flatpickr/dist/themes/material_green.css";
import Spinners from "Components/Common/Spinner";
import { useStaffFindAllQuery, useStaffCreateMutation, useRoleFindAllQuery, useUserRoleFindAllQuery, useUserRoleCreateMutation, useUserRoleDeleteMutation, useOrgFindAllQuery, useDepartmentFindAllQuery, usePositionFindAllQuery, useLegalEntityFindAllQuery, useStaffUpdateMutation, useStaffDeleteMutation } from '../../../store';

const Detail = () => {

  const [customQuery, setCustomQuery] = useState<any>();
  const [customUserRoleQuery, setCustomUserRoleQuery] = useState<any>();
  const [isLoading, setLoading] = useState(true)

  const [modal, setModal] = useState<boolean>(false);
  const [roleModal, setRoleModal] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isRoleEdit, setIsRoleEdit] = useState<boolean>(false);
  const [staffOne, setStaffOne] = useState<any>(null)
  const [staffList, setStaffList] = useState<any>();
  const [staffCount, setStaffCount] = useState<any>();

  const [orgSelected, setOrgSelected] = useState<any>(null);
  const [deptSelected, setDeptSelected] = useState<any>(null);

  const [roleList, setRoleList] = useState<any>();
  const [myRoleList, setMyRoleList] = useState<any>();
  const [createUserRoleId, setCreateUserRoleId] = useState<any>();

  const {
    data: staffData,
    error: staffError,
    isFetching: isStaffFetching,
  } = useStaffFindAllQuery(customQuery);

  const {
    data: roleData,
    error: roleError,
    isFetching: isRoleFetching,
  } = useRoleFindAllQuery();

  const {
    data: myRoleData,
    error: myRoleError,
    isFetching: myRoleFetching,
  } = useUserRoleFindAllQuery(customUserRoleQuery, { skip: !customUserRoleQuery });


  const {
    data: orgaId,
    error: orgaIdError,
    isFetching: orgaIdFetching,
  } = useOrgFindAllQuery();

  const {
    data: departId,
    error: departIdError,
    isFetching: departIdFetching,
  } = useDepartmentFindAllQuery(orgSelected !== null ? `?organization_id=${orgSelected}` : '');


  const {
    data: positionId,
    error: positionIdError,
    isFetching: positionIdFetching,
  } = usePositionFindAllQuery(deptSelected !== null ? `?organization_id=${orgSelected}&department_id=${deptSelected}` : '');

  const {
    data: legalEntityId,
    error: legalEntityIdError,
    isFetching: legalEntityIdFetching,
  } = useLegalEntityFindAllQuery();

  const [staffCreate, staffCreateResult] = useStaffCreateMutation();
  const [staffUpdate, staffUpdateResult] = useStaffUpdateMutation();
  const [staffDelete, staffDeleteResult] = useStaffDeleteMutation();
  const [userRoleCreate, userRoleResult] = useUserRoleCreateMutation();
  const [userRoleDelete] = useUserRoleDeleteMutation();

  // Datatable дээр pagination харуулахад хэрэгтэй
  const [customPagination, setCustomPagination] = useState<any>();
  const [customPageSize, setCustomPageSize] = useState<any>();
  const [customPageLength, setCustomPageLength] = useState<any>();

  useEffect(() => {
    console.log(orgSelected);

    setStaffList(staffData?.data)
    setLoading(false)
    setStaffCount(staffList?.length)

    setRoleList(roleData?.data)

    setCustomPagination(staffData?.pagination);
    const tempQuery = `?page=${customPageLength !== undefined ? customPageLength : 1}&pageSize=${customPageSize !== undefined ? customPageSize : 25}`;
    setCustomQuery(tempQuery)

    // if (staffOne !== null) {
    //   const tempRoleQuery = `${staffOne?.legal_entity_id !== undefined ? `?user_id=${staffOne?.legal_entity_id}` : ''} `;
    //   setCustomUserRoleQuery(tempRoleQuery);
    //   setMyRoleList(myRoleData?.data)
    // }

    console.log(departId);


  }, [staffData, staffList, customPageSize, customPageLength, customPagination, roleModal, myRoleList, orgaId, departId, positionId, legalEntityId])

  useEffect(() => {
    if (!staffOne?.id) {
      setCustomUserRoleQuery(undefined);
      return;
    }

    setCustomUserRoleQuery(`?user_id=${staffOne.id}`);
  }, [staffOne]);

  useEffect(() => {
    if (myRoleData?.data) {
      setMyRoleList(myRoleData.data);
      setCreateUserRoleId(myRoleData.data[0]?.role_id ?? roleList?.[0]?.id);
    }
  }, [myRoleData, roleList]);

  const toggle = useCallback(() => {
    if (modal || roleModal) {
      setModal(false);
      setRoleModal(false);
      setStaffOne(null);
    } else {
      roleModal === false ? setModal(true) : setRoleModal(false);
    }
  }, [modal, roleModal]);

  const handleJobClick = useCallback((arg: any) => {
    const tempStaff = arg;
    // console.log(tempStaff);

    setStaffOne({
      id: tempStaff.id,
      lname: tempStaff.lname,
      fname: tempStaff.fname,
      organization_id: tempStaff.organization_id,
      department_id: tempStaff.department_id,
      position_id: tempStaff.position_id,
      legal_entity_id: tempStaff.legal_entity_id,
      phono_no: tempStaff.phono_no,

      username: tempStaff.username,
      email: tempStaff.email,
    });
    setIsEdit(true);
    toggle();
  }, []);

  //delete Job
  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = (staffData) => {
    setStaffOne(staffData);

    setDeleteModal(true);
  };

  const handleDeletejob = () => {
    if (staffOne) {
      setDeleteModal(false);
      staffDelete(staffOne.id)
        .unwrap()
        .then((response) => {
          toastr.success("Мэдээлэл амжилттай устсан!", "Амжилттай");
        })
        .catch((error) => {
          toastr.error("Амжилтгүй!", "Амжилтгүй");
        })
    }
  };
  const handleJobClicks = () => {
    setIsEdit(false);
    setStaffOne(null);
    toggle();
  };

  // const RoleEdit = () => {
  //   setRoleModal(true)
  //   setIsRoleEdit(true)
  // }
  const RoleEdit = (staffData) => {
    setStaffOne(staffData);
    setIsRoleEdit(true);
    setRoleModal(true);
  };

  const saveUserRole = async () => {
    if (!staffOne?.id || !createUserRoleId) {
      toastr.error("Хэрэглэгч болон хандах эрхийг сонгоно уу!", "Амжилтгүй");
      return;
    }

    const userRole = {
      role_id: Number(createUserRoleId),
      user_id: Number(staffOne.id),
    };

    try {
      const alreadyAssigned = myRoleList?.some(
        (item) => Number(item.role_id) === userRole.role_id
      );

      if (alreadyAssigned) {
        toastr.warning("Энэ хандах эрх хэрэглэгчид аль хэдийн оноогдсон байна!", "Анхааруулга");
        return;
      }

      await userRoleCreate(userRole).unwrap();
      toastr.success("Хандах эрх амжилттай хадгалагдлаа!", "Амжилттай");
    } catch (error: any) {
      toastr.error(error?.data?.error || "Хандах эрх хадгалахад алдаа гарлаа!", "Амжилтгүй");
    }
  }

  const detachUserRole = async (userRoleId: number) => {
    if (!window.confirm("Энэ хандах эрхийг хэрэглэгчээс салгах уу?")) return;

    try {
      await userRoleDelete(userRoleId).unwrap();
      toastr.success("Хандах эрх амжилттай салгагдлаа!", "Амжилттай");
    } catch (error: any) {
      toastr.error(error?.data?.error || "Хандах эрх салгахад алдаа гарлаа!", "Амжилтгүй");
    }
  }

  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      organization_id: staffOne?.organization_id,
      department_id: staffOne?.department_id,
      position_id: staffOne?.position_id,
      legal_entity_id: staffOne?.legal_entity_id,

      username: staffOne?.username,
      email: staffOne?.email,
      password: staffOne?.password,

      fname: staffOne?.fname,
      lname: staffOne?.lname,

    },
    validationSchema: Yup.object({
    }),
    onSubmit: (values: any) => {
      // console.log(values);

      if (isEdit) {
        const updateStaffList = {
          id: staffOne ? staffOne.id : 0,
          lname: values?.lname,
          fname: values?.fname,
          organization_id: values?.organization_id,
          department_id: values?.department_id,
          position_id: values?.position_id,
          legal_entity_id: values?.legal_entity_id,
          username: values?.username,
          email: values?.email,
        };
        console.log("updateStaffList" + updateStaffList)
        staffUpdate(updateStaffList)
          .unwrap()
          .then((response) => {
            toastr.success("Мэдээлэл амжилттай засагдлаа!", "Амжилттай");
          })
          .catch((error) => {
            toastr.error("Мэдээлэл амжилтгүй!", "Амжилтгүй");
          })
      } else {
        const newStaffList = {
          lname: values["lname"],
          fname: values["fname"],
          organization_id: values["organization_id"],
          department_id: values["department_id"],
          position_id: values["position_id"],
          legal_entity_id: values["legal_entity_id"],
          username: values["username"],
          email: values["email"],
          password: values["password"],
        };
        console.log(newStaffList);

        staffCreate(newStaffList)
          .unwrap()
          .then((response) => {
            toastr.success("Мэдээлэл амжилттай орлоо!", "Амжилттай");
          })
          .catch((error) => {
            toastr.error("Мэдээлэл амжилтгүй!", "Амжилтгүй");
          })
      }
      validation.resetForm();
      toggle();
    },
  });

  const columns = useMemo(
    () => [
      {
        header: '№',
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps: any) => {
          return <Link to="#" className="text-body fw-bold">{cellProps.row.original.id}</Link>
        }
      },
      {
        header: "Овог",
        accessorKey: "lname",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Нэр',
        accessorKey: "fname",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Регистерийн дугаар',
        accessorKey: "legalEntity.register",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Байгууллага',
        accessorKey: "organization_name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Хэлтэс',
        accessorKey: "department_name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Албан тушаал',
        accessorKey: "position_name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Үйлдэл',
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cellProps: any) => {
          const rowId = cellProps.row.id;
          return (
            <ul className="list-unstyled hstack gap-1 mb-0 ">
              <li>
                <Link
                  to="#"
                  id={`edittooltip-${rowId}`}
                  className="btn btn-sm btn-soft-info"
                  onClick={(event: any) => {
                    const staffData = cellProps.row.original;
                    event.preventDefault();
                    handleJobClick(staffData);
                    setOrgSelected(cellProps.row.original.organization_id)
                    setDeptSelected(cellProps.row.original.department_id)
                  }}
                >
                  <i className="mdi mdi-pencil-outline" />
                </Link>
                <UncontrolledTooltip placement="top" target={`edittooltip-${rowId}`}>
                  Засах
                </UncontrolledTooltip>
              </li>

              <li>
                <Link
                  to="#"
                  id={`deletetooltip-${rowId}`}
                  className="btn btn-sm btn-soft-danger"
                  onClick={(event: any) => {
                    const staffData = cellProps.row.original;
                    event.preventDefault();
                    onClickDelete(staffData);
                  }}
                >
                  <i className="mdi mdi-delete-outline" />
                </Link>
                <UncontrolledTooltip placement="top" target={`deletetooltip-${rowId}`}>
                  Soft delete
                </UncontrolledTooltip>
              </li>

              <li>
                <Link
                  to="#"
                  id={`roletooltip-${rowId}`}
                  className="btn btn-sm btn-soft-success"
                  onClick={(event: any) => {
                    const staffData = cellProps.row.original;
                    event.preventDefault();
                    setStaffOne(staffData)
                    RoleEdit(staffData);
                  }}
                >
                  <i className="mdi mdi-shield-key" />
                </Link>
                <UncontrolledTooltip placement="top" target={`roletooltip-${rowId}`}>
                  Хандах эрх
                </UncontrolledTooltip>
              </li>
            </ul>

          );
        }
      },
    ],
    [handleJobClick, RoleEdit]
  );

  return (
    <React.Fragment>
      <DeleteModal
        deleteName={staffOne?.fname}
        show={deleteModal}
        onDeleteClick={handleDeletejob}
        onCloseClick={() => setDeleteModal(false)}
      />
      <Row>
        <Col lg={12}>
          <Card>
            <CardBody className="border-bottom">
              <div className="d-flex align-items-center">
                <img src={staffSvg} alt="" height="50" />
                <div className="flex-grow-1 ms-3">
                  <h5 className="fw-semibold">Мэдээлэл</h5>
                  <ul className="list-unstyled hstack gap-2 mb-0">
                    <li>
                      <i className="mdi mdi-table-row-height"></i> <span className="text-muted fw-semibold">Нийт: {numberWithCommas(staffCount)}</span>
                    </li>
                  </ul>
                </div>
                <button
                  type="button"
                  onClick={() => {
                    handleJobClicks();
                  }}
                  className="btn btn-success  btn-label"
                >
                  <i className="mdi mdi-file-plus-outline label-icon"></i> Шинээр нэмэх
                </button>
              </div>
            </CardBody>
            <CardBody>
              {
                isLoading ? <Spinners setLoading={setLoading} />
                  :

                  <TableContainer
                    setCustomPageSize={setCustomPageSize}
                    setCustomPageLength={setCustomPageLength}
                    customPagination={customPagination}
                    columns={columns}
                    data={staffList || ""}
                    isCustomPageSize={true}
                    // isGlobalFilter={true}
                    isPagination={true}
                    colWidth={2}
                    SearchPlaceholder="Хэрэглэгч хайх . . ."
                    tableClass="align-middle dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                    pagination="pagination"
                    paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                  />
              }
            </CardBody>
          </Card>

        </Col>
      </Row>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle} tag="h4">
          {!!isEdit ? "Ажилтан засах" : "Ажилтан нэмэх"}
        </ModalHeader>
        <ModalBody>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <Row>
              <Col xs={12}>
                <div className="mb-3">
                  <Label>Байгууллага</Label>
                  <Input
                    name="organization_id"
                    type="select"
                    onChange={(e) => {
                      validation.handleChange(e);
                      setOrgSelected(e.target.value);
                    }}
                    onBlur={validation.handleBlur}
                    value={
                      validation.values.organization_id || ""
                    }
                    invalid={
                      validation.touched.organization_id && validation.errors.organization_id ? true : false
                    }

                  >
                    <option disabled value="">Сонгох</option>
                    {orgaId?.data?.map((item, index) => (
                      <option value={item?.organization_id}>{item?.name}</option>
                    ))}

                  </Input>
                  {validation.touched.organization_id && validation.errors.organization_id ? (
                    <FormFeedback organization_id="invalid">{validation.errors.organization_id}</FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label>Хэлтэс</Label>
                  <Input

                    name="department_id"
                    type="select"
                    onChange={(e) => {
                      validation.handleChange(e);
                      setDeptSelected(e.target.value);
                    }}
                    onBlur={validation.handleBlur}
                    value={
                      validation.values.department_id || ""
                    }
                    invalid={
                      validation.touched.department_id && validation.errors.department_id ? true : false
                    }
                  >
                    <option disabled value="">Сонгох</option>
                    {departId?.data?.map((item, index) => (
                      <option value={item?.department_id}>{item?.department_name}</option>
                    ))}

                  </Input>
                  {validation.touched.department_id && validation.errors.department_id ? (
                    <FormFeedback department_id="invalid">{validation.errors.department_id}</FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label>Албан тушаал</Label>
                  <Input
                    name="position_id"
                    type="select"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={
                      validation.values.position_id || ""
                    }
                    invalid={
                      validation.touched.position_id && validation.errors.position_id ? true : false
                    }
                  >
                    <option disabled value="">Сонгох</option>
                    {positionId?.data?.map((item, index) => (
                      <option value={item?.position_id}>{item?.position_name}</option>
                    ))}

                  </Input>
                  {validation.touched.position_id && validation.errors.position_id ? (
                    <FormFeedback position_id="invalid">{validation.errors.position_id}</FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label>Хуулийн этгээд</Label>
                  <Input
                    name="legal_entity_id"
                    type="select"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={
                      validation.values.legal_entity_id || ""
                    }
                    invalid={
                      validation.touched.legal_entity_id && validation.errors.legal_entity_id ? true : false
                    }
                  >
                    <option disabled value="">Сонгох</option>
                    {legalEntityId?.data?.map((item, index) => (
                      <option value={item?.id}>{item?.lname} - {item?.fname}</option>
                    ))}

                  </Input>
                  {validation.touched.legal_entity_id && validation.errors.legal_entity_id ? (
                    <FormFeedback legal_entity_id="invalid">{validation.errors.legal_entity_id}</FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label>Овог</Label>
                  <Input
                    name="lname"
                    type="text"
                    validate={{
                      required: { value: true },
                    }}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.lname || ""}
                    invalid={
                      validation.touched.lname && validation.errors.lname ? true : false
                    }
                  />
                  {validation.touched.lname && validation.errors.lname ? (
                    <FormFeedback type="invalid">{validation.errors.lname}</FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label>Нэр</Label>
                  <Input
                    name="fname"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.fname || ""}
                    invalid={
                      validation.touched.fname && validation.errors.fname ? true : false
                    }
                  />
                  {validation.touched.fname && validation.errors.fname ? (
                    <FormFeedback type="invalid">{validation.errors.fname}</FormFeedback>
                  ) : null}
                </div>
                {/* <div className="mb-3">
                  <Label>Утас</Label>
                  <Input
                    name="phono_no"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.phono_no || ""}
                    invalid={
                      validation.touched.phono_no && validation.errors.phono_no ? true : false
                    }
                  />
                  {validation.touched.phono_no && validation.errors.phono_no ? (
                    <FormFeedback type="invalid">{validation.errors.phono_no}</FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label>Регистерийн дугаар</Label>
                  <Input
                    name="register"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.register || ""}
                    invalid={
                      validation.touched.register && validation.errors.register ? true : false
                    }
                  />
                  {validation.touched.register && validation.errors.register ? (
                    <FormFeedback type="invalid">{validation.errors.register}</FormFeedback>
                  ) : null}
                </div> */}

                <div className="mb-3">
                  <Label> Нэвтрэх нэр </Label>
                  <Input
                    name="username"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.username || ""}
                    invalid={
                      validation.touched.username && validation.errors.username ? true : false
                    }
                  />
                  {validation.touched.username && validation.errors.username ? (
                    <FormFeedback type="invalid">{validation.errors.username}</FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label> Цахим шуудан </Label>
                  <Input
                    name="email"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.email || ""}
                    invalid={
                      validation.touched.email && validation.errors.email ? true : false
                    }
                  />
                  {validation.touched.email && validation.errors.email ? (
                    <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                  ) : null}
                </div>

                {isEdit ? '' :
                  <>
                    <div className="mb-3">
                      <Label> Нууц үг </Label>
                      <Input
                        name="password"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.password || ""}
                        invalid={
                          validation.touched.password && validation.errors.password ? true : false
                        }
                      />
                      {validation.touched.password && validation.errors.password ? (
                        <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                      ) : null}
                    </div>
                  </>
                }



              </Col>
            </Row>
            <Row>
              <Col>
                <div className="text-end">
                  <Button type="submit" color="success" className="save-user" > Хадгалах</Button>
                </div>
              </Col>
            </Row>
          </Form>
        </ModalBody>
      </Modal>

      <Modal isOpen={roleModal} toggle={toggle}>
        <ModalHeader toggle={toggle} tag="h4">Хандах эрх</ModalHeader>
        <ModalBody>

          <Row>
            <Col xs={12}>

              <div className="mb-3">
                <Label>Хандах эрх</Label>
                <Input
                  name="role_id"
                  type="select"
                  className="form-select"
                  value={createUserRoleId ?? ""}
                  onChange={(e) => setCreateUserRoleId(e.target.value)}
                >
                  <option value="" disabled>Хандах эрх сонгоно уу</option>
                  {roleList?.map((role) => (
                    <option key={role.id} value={role.id}>
                      {role.name}
                    </option>
                  ))}
                </Input>

                <div className="d-flex flex-row flex-wrap gap-2 mt-3">
                  {myRoleList?.map((myRole) => (
                    <button
                      key={myRole.id}
                      type="button"
                      className="btn btn-primary"
                      onClick={() => detachUserRole(myRole.id)}
                      title="Хандах эрх салгах"
                    >
                      {myRole?.role?.name} <i className="mdi mdi-close ms-1" />
                    </button>
                  ))}
                </div>


              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="text-end">
                <Button type="button" onClick={saveUserRole} color="success" className="save-user">Нэмэх</Button>
              </div>
            </Col>
          </Row>

        </ModalBody>
      </Modal>
    </React.Fragment>
  );
}


export default Detail;
